import { apiDomain } from "env";

const buscaDadosValoresContrato = (periodoDe, periodoAte, contratoId) =>
  `${apiDomain(
    "portal/beneficiario"
  )}/valores/download?periodoDe=${periodoDe}&periodoAte=${periodoAte}&contratos=${contratoId}`;

const buscaDadosMensalidade = (periodoDe, periodoAte, contratoId) =>
  `${apiDomain(
    "portal/beneficiario"
  )}/mensalidades/download?periodoDe=${periodoDe}&periodoAte=${periodoAte}&contratos=${contratoId}`;

const getDadosTitular = codigoBeneficiario =>
  `${apiDomain(
    "portal/beneficiario"
  )}/dados_titular/download?codigoBeneficiario=${codigoBeneficiario}`;

export default {
  buscaDadosValoresContrato,
  buscaDadosMensalidade,
  getDadosTitular
};
